// VIVA-980: el motivo real del rechazo viene en el cuerpo de la respuesta. El
// backend es ASP.NET, asi que una validacion de 400 llega como
// ValidationProblemDetails: `{ title, status, errors: { Campo: ["motivo"] } }`,
// sin ningun campo `message`. Eso se estaba tirando y el usuario terminaba
// viendo la cadena tecnica de axios ("Request failed with status code 400") o,
// si el esquema de textos no habia cargado, un aviso vacio.
//
// Vivia en `useEventForm.js`. Se movio aqui en VIVA-353 al necesitarlo tambien la
// seccion de comentarios del evento: la misma normalizacion en dos pantallas se
// comparte, no se copia.
export const getApiFieldErrors = (error) => {
  const responseData = error?.response?.data;
  const rawErrors = responseData?.errors || responseData?.Errors;
  if (!rawErrors || typeof rawErrors !== "object") return {};

  return Object.entries(rawErrors).reduce((fieldErrors, [field, detail]) => {
    const text = Array.isArray(detail)
      ? detail.filter(Boolean).join(" ")
      : String(detail ?? "").trim();
    if (text) fieldErrors[field] = text;
    return fieldErrors;
  }, {});
};

export const getApiErrorMessage = (error) => {
  const responseData = error?.response?.data;
  if (typeof responseData === "string" && responseData.trim()) {
    return responseData.trim();
  }

  const fieldMessages = Object.values(getApiFieldErrors(error));

  // Nunca se devuelve `error.message`: es la cadena tecnica de axios, en ingles.
  // Si el backend no explico nada, quien llama pone el mensaje de la aplicacion.
  return (
    responseData?.message ||
    responseData?.Message ||
    (fieldMessages.length ? fieldMessages.join(" · ") : "") ||
    responseData?.title ||
    responseData?.detail ||
    ""
  );
};
